// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__22Voc"};